import { render, staticRenderFns } from "./environmentalReportYears.vue?vue&type=template&id=06e72b70"
import script from "./environmentalReportYears.vue?vue&type=script&lang=js"
export * from "./environmentalReportYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports